import {ODRoute} from '@mdpp/od-react-belt'
import {SiteUrls} from '../SiteUrls'
import {HanmiManagerDashboardContainer} from './dashboard/HanmiManagerDashboardContainer'

// https://github.com/ReactTraining/react-router/tree/master/packages/react-router-config
export const HanmiManagerRoutes: ODRoute[] = [
  { path: SiteUrls.HanmiManager.Dashboard.Main, exact: true, name: `대시보드`, component: HanmiManagerDashboardContainer },
]
